import { Pagination } from 'react-bootstrap';
const POST_PER_PAGE = 10;
const PaginationCompAdminPayment = ({
  pageMaxNo,
  active,
  history,
  url
}) => {
  //0. 총 게시물의 갯수 : n
  //1. 몇개의 게시물씩 보여줄지: 10
  //2. 그 중 몇번째 페이지인지: i
  console.log(`pageMaxNo: ${pageMaxNo}\nactive: ${active}`);
  let items = [];
  const onClickPage = (number) => {
    console.log(number);
    const tmpArray = window.location.toString().split("?")[1].split("&");
    var params="pageNo="+number+"&";
    for(var i=0; i<tmpArray.length; i++ ){
      console.log(i+'번째 : '+ tmpArray[i]);
      // if(i!=0) params=params+ tmpArray[i] +"&";
      if(i!=0){
        if(i!=tmpArray.length-1){
          params=params+ tmpArray[i] +"&";
        }
      }
    }
    console.log("#####", params);
    history.push("/admin/reception/"+url+"?"+params);
  };
  for (let i = 1; i < pageMaxNo + 1; i++) {
    items.push(
      <Pagination.Item
        key={i}
        active={i === parseInt(active)}
        onClick={() => {onClickPage(i);}}
      >
        {i}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <Pagination style={{justifyContent: 'center'}}>{items}</Pagination>
    </div>
  );
};
export default PaginationCompAdminPayment;
